import * as React from 'react';
import config from '../../config';
import {Box, Container, Paper, Typography} from '@mui/material';
import {branchHelper} from '../../helpers/branch-helper';
import {LOCAL_STORAGE} from '../../constants/constants';
import {jwtDecode} from 'jwt-decode';
import {getEnvironmentLabel} from '../../helpers/string-helper';

const UserInfoFooter = () => {
  const accessToken = localStorage.getItem(LOCAL_STORAGE.JJ_INTERNAL);
  const tokenProperties = jwtDecode(accessToken);
  const userGroups = tokenProperties.groups

  return (
    <Paper component="footer" elevation={0} square
           sx={{
             border: 'none',
           }}
    >
      <Container
        sx={{
          border: 'none'
        }}
      >
        <Box sx={{
          py: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          color: 'text.secondary',
          fontSize: '0.875rem',
          border: 'none'
        }}>
          <Typography variant="body2" sx={{fontWeight:'bold', textAlign:'center'}}>{tokenProperties ? `${tokenProperties.name}` : 'Username Missing'}</Typography>
          <Typography variant="body2" sx={{textAlign:'center'}}>{tokenProperties ? `${tokenProperties.groups.length > 0 ? branchHelper(userGroups)[0] : "??-MW"}` : '??-MW'}</Typography>
          <Typography variant="body2" sx={{textAlign:'center'}}>{new Date().toLocaleDateString().split('/').reverse().join('-')}</Typography>
          <Typography variant="body2" sx={{textAlign:'center'}}>{getEnvironmentLabel()} - v{ config.version}</Typography>
        </Box>
      </Container>
    </Paper>
  );
};

export default UserInfoFooter;